import React from 'react';
import styles from './Footer.module.css';
import { Facebook, Twitter, LinkedIn, GitHub, Telegram, WhatsApp } from '@mui/icons-material'



export default function Footer () {
  return (
    <div className={styles.footer}>
      <aside className={styles.name}>
        <p> © Ezelu Joseph John 2022 </p>
      </aside>

      <aside className={styles.links}>
          <a href="https://facebook.com/ezelujhay1"  target="_blank" title='Facebook'> <Facebook /> </a>
          <a href="https://twitter.com/ezelujhay"  target="_blank" title='Twitter'> <Twitter /> </a>
          <a href="https://linkedin.com/in/ezelujhay"  target="_blank" title="LinkedIn"> <LinkedIn /> </a>
          <a href="https://github.com/ezelu"  target="_blank" title="Github"> <GitHub /> </a>
          <a href="https://wa.me/+2347085186134" title="Email" target="_blank" > <WhatsApp /> </a>
          <a href="https://t.me/ezelu_jhay"  target="_blank" title='Telegram'> <Telegram /> </a>
      </aside>
    </div>
  )
}